// Dashboard nudge: active packages running low / near expiry — "talk to them /
// schedule more". Hidden entirely when there's nothing to follow up.
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { usePackageReminders } from "../hooks/packages";
import { cn } from "../lib/cn";

export function PackageReminderStrip() {
  const { t } = useTranslation("packages");
  const { data } = usePackageReminders();
  const reminders = data ?? [];
  if (reminders.length === 0) return null;
  return (
    <section className="rounded-md bg-amber-soft/50 p-3 ring-1 ring-amber/30">
      <p className="mb-2 font-display text-xs font-bold uppercase tracking-kicker text-amber-600">
        {t("reminderTitle")}
      </p>
      <ul className="flex flex-col gap-1">
        {reminders.map((r) => (
          <li key={r.package_id ?? `${r.client_id ?? ""}-${r.expires_on}`}>
            <Link
              to={`/app/clients/${r.client_id ?? ""}`}
              className={cn(
                "flex items-center justify-between gap-2 rounded px-2 py-1 text-sm hover:bg-surface",
                r.tone === "amber" ? "text-ember-700" : "text-body",
              )}
            >
              <span className="truncate font-bold">{r.client_name}</span>
              <span className="shrink-0 text-xs">
                {t("remaining", { count: r.remaining })} ·{" "}
                {t("expiresLabel", { date: r.expires_on })}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
